import Element from './Element';
import UINineSliceComponent from '../../Component/UI/NineSlice';

export default class LivesItem extends Element {
    public create(params: any): void {
        super.create({
            type: 'group',
            layout: {
                anchors: [0, 0, 1, 0],
                offsets: [0, 0, 0, 0],
                pivot: [0.5, 0],
                constrains: {
                    heightMin: 104,
                    heightMax: 104,
                    widthMin: 500,
                    widthMax: 500,
                },
            },
            components: [
                {
                    type: 'nineslice',
                    data: {
                        cacheKey: 'rounded_rectangle1_9_slice',
                        offset: [15, 15, 15, 15],
                    },
                },
            ],
            children: [
                {
                    type: 'group',
                    name: 'heart',
                    layout: {
                        anchors: [0, 0, 0, 1],
                        pivot: [0.5, 0.5],
                        offsets: [-50, 0, -50, 0],
                        scale: [0.5, 0.5],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'ui_lives_icon',
                            },
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'lives',
                    layout: {
                        anchors: [0, 0, 0, 1],
                        pivot: [0.5, 0.5],
                        offsets: [-50, 0, -50, 0],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textLocalizationKey: '0',
                                style: {
                                    font: 'RussoOne',
                                    fill: '#FFF',
                                    fontSize: '36px',
                                },
                                align: 'center',
                            },
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'avatar',
                    layout: {
                        anchors: [0, 0, 0, 1],
                        pivot: [0.5, 0.5],
                        offsets: [-145, 0, -145, 0],
                        constrains: {
                            heightMin: 78,
                            heightMax: 78,
                            widthMin: 78,
                            widthMax: 78,
                        },
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'no_avatar',
                            },
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'name',
                    layout: {
                        anchors: [0.42, 0, 0.42, 0],
                        pivot: [0, 0],
                        offsets: [0, -10, 0, -10],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textUnlocalized: params.playerName,
                                style: {
                                    font: 'RussoOne',
                                    fill: '#531E0F',
                                    fontSize: '28px',
                                },
                                align: 'left',
                                bounds: [280, 30],
                            },
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'send_button',
                    layout: {
                        anchors: [0.54, 0.7, 0.54, 0.7],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [0.45, 0.45],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'button_blue',
                            },
                        },
                        {
                            type: 'input',
                            data: {
                                enabled: true,
                            },
                        },
                    ],
                    children: [
                        {
                            type: 'group',
                            name: 'name',
                            layout: {
                                anchors: [0, 0, 1, 1],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: 'SEND',
                                        style: {
                                            font: 'RussoOne',
                                            fill: '#FFF',
                                            fontSize: '36px',
                                        },
                                        align: 'center',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'request_button',
                    layout: {
                        anchors: [0.84, 0.7, 0.84, 0.7],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [0.45, 0.45],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'button_blue',
                            },
                        },
                        {
                            type: 'input',
                            data: {
                                enabled: true,
                            },
                        },
                    ],
                    children: [
                        {
                            type: 'group',
                            name: 'name',
                            layout: {
                                anchors: [0, 0, 1, 1],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: 'REQUEST',
                                        style: {
                                            font: 'RussoOne',
                                            fill: '#FFF',
                                            fontSize: '36px',
                                        },
                                        align: 'center',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
            ...params,
        });
    }

    protected onCreate(params: any): void {
        super.onCreate(params);

        this.getComponent(UINineSliceComponent).tint = 0xffe9d5;
    }
}
